import accountManagementReducer from "@features/account-management/accountManagementSlice"
import courseEditorReducer from "@features/courseEditor/courseEditorSlice"
import courseViewReducer from "@features/courseView/courseViewSlice"
import coursesMenuReducer, {
  TabIdentifierEnumeration,
} from "@features/coursesMenu/coursesMenuSlice"
import loginReducer from "@features/login/loginSlice"
import programReducer from "@features/program/programSlice"
import programsMenuReducer from "@features/program/programsMenuSlice"
import searchReducer from "@features/search/searchSlice"
import syllabusesMenuReducer from "@features/syllabus/syllabusesMenuSlice"
import syllabusEditorReducer from "@features/syllabusEditor/syllabusEditorSlice"
import uiReducer from "@features/ui/uiSlice"
import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit"
import { SortOrder, SortType } from "../main/sort/coursesSortHelpers"
import observersMiddleware from "./middlewares/observersMiddleware"
import projectsTabReducer from "@features/projects-tab/projectsTabSlice"
import programProjectsReducer from "@features/program/projects/programProjectsSlice"
import slackReducer from "@features/slack/slackSlice"
import appFeatureFlagReducer from "@features/app-feature-flags/appFeatureFlagsSlice"
import salesManagementReducer from "@features/sales-management/salesManagement.slice"
import leadRoutingReducer from "@features/lead-routing/leadRouting.slice"
import usersTabReducer from "@features/users-tab/usersTabSlice"
import studentsTabReducer from "@features/students-tab/studentsTab.slice"
import trackReducer from "@features/tracks/trackSlice"
import { CourseType } from "@masterschool/course-builder-api"
import termReducer from "@features/term/termSlice"
import courseInstanceReducer from "@features/courseInstance/courseInstanceSlice"

export const store = configureStore({
  reducer: {
    term: termReducer,
    courseEditor: courseEditorReducer,
    coursesMenu: coursesMenuReducer,
    courseView: courseViewReducer,
    search: searchReducer,
    syllabusesMenu: syllabusesMenuReducer,
    syllabusEditor: syllabusEditorReducer,
    track: trackReducer,
    courseInstance: courseInstanceReducer,
    ui: uiReducer,
    program: programReducer,
    programsMenu: programsMenuReducer,
    login: loginReducer,
    accountManagement: accountManagementReducer,
    projectsTab: projectsTabReducer,
    programProjects: programProjectsReducer,
    slack: slackReducer,
    appFeatureFlags: appFeatureFlagReducer,
    salesManagement: salesManagementReducer,
    leadRouting: leadRoutingReducer,
    studentsTab: studentsTabReducer,
    usersTab: usersTabReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(observersMiddleware),
  preloadedState: {
    coursesMenu: {
      favoriteCourses: JSON.parse(
        localStorage.getItem("favoriteCourses") ?? "[]",
      ),
      courses: "pending",
      sortOption: {
        type: SortType.Alphabetic,
        order: SortOrder.Descending,
      },
      tab: TabIdentifierEnumeration.Published,
      highlightedCourseId: undefined,
      type:
        (localStorage.getItem("courseMenuType") as CourseType) ??
        CourseType.Legacy,
    },
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
